module.exports = __webpack_public_path__ + "img/HoodieGrey.cfc89e92.png";